import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import classnames from 'classnames';
import { PureComponent } from 'react';
import './ingredient.less';
export class Ingredient extends PureComponent {
    render() {
        const rootClass = classnames({
            ingredient: true,
        }, this.props.className);
        return (_jsxs("div", Object.assign({ className: rootClass }, { children: [_jsx("p", Object.assign({ className: "ingredient__title" }, { children: this.props.title })), _jsxs("a", Object.assign({ className: "ingredient__link", href: this.props.url, rel: "noopener noreferrer", target: "_blank" }, { children: ["Learn more", ' ', _jsx(DixaIcon, { icon: "external-link", className: "ingredient__link__icon" })] }))] })));
    }
}
